import api from "@/services/api.js";
import { uuid } from "vue-uuid";

const updatePassword = async (email, oldPassword, newPassword) => {
  const passwords = {
    oldPassword: oldPassword,
    newPassword: newPassword,
  };

  const response = await api.put(
    "/useraccount/updatePassword/" + email,
    passwords
  );
  return response;
};

const resetPassword = async (resetToken, newPassword) => {
  const resetData = {
    resetToken: resetToken,
    newPassword: newPassword,
  };

  const response = await api.put("/useraccount/resetPassword", resetData);
  return response;
};

const initiateResetPassword = async (email) => {
  const resetToken = uuid.v1();
  const resetData = {
    resetToken: resetToken,
  };

  const response = await api.put(
    "/useraccount/initiateResetPassword/" + email,
    resetData
  );
  return response;
};

const initiateEmailVerification = async (email, userId = 0) => {
  const data = {
    resetToken: uuid.v1(),
    email: email,
    userId: userId,
  };

  const response = await api.put("/useraccount/initEmailVerification", data);
  return response;
};

const verifyEmail = async (resetToken) => {
  const data = {
    resetToken: resetToken,
  };

  const response = await api.put("/useraccount/verify", data);
  return response;
};

const alterPortfolioBlocked = async (userId, portfolios) => {
  if (!userId || !portfolios) return;

  const payload = {
    userId: userId,
    portfolios: portfolios,
  };

  return await api.put("/useraccount/alterBlockedPortfolios", payload);
};

const getUserByUd = async (userId) => {
  return await api.get("/useraccount/user/" + userId);
};

const updateUserData = async (data) => {
  if (!data || !data.userId) return;

  return await api.put("/useraccount/updateUserData", data);
};

const getUserCategorySetting = async (userId) => {
  if (!userId) return;

  return await api.get("/useraccount/getCategorySetting/" + userId);
};

const updateUserCategorySetting = async (data) => {
  if (!data.userId) return;

  return await api.put("/useraccount/updateCategorySetting", data);
};

const getUserHomepage = async (userId) => {
  if (!userId) return;

  return await api.get("/useraccount/getUserHomepage/" + userId);
};

const updateHomepage = async (data) => {
  if (!data.userId) return;

  return await api.put("/useraccount/updateUserHomepage", data);
};

export default {
  updatePassword,
  resetPassword,
  initiateResetPassword,
  initiateEmailVerification,
  verifyEmail,
  alterPortfolioBlocked,
  getUserByUd,
  updateUserData,
  getUserCategorySetting,
  updateUserCategorySetting,
  getUserHomepage,
  updateHomepage,
};
